import React, {Component} from 'react';
import {controlMaxWidthStyle, errorMessageStyle} from '../styles';
import AuthenticationService from './authentication-service';

export default class PasswordReset extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newPassword: '',
            confirmPassword: '',
            isResetting: false,
            errorMessage: ''
        };
        this.authenticationService = AuthenticationService;
    }

    inputChanged = e => {
        const state = this.state;
        state[e.target.id] = e.target.value;
        this.setState(state);
    };

    resetPassword = () => {
        this.setState({isResetting: true, errorMessage: ''});
        this.authenticationService.resetPassword(this.state.newPassword)
            .done(() => this.props.onReset())
            .fail(e => this.setState({errorMessage: e.responseText}))
            .always(() => this.setState({isResetting: false}));
    };

    validate = () => {
        if (this.state.newPassword && this.state.confirmPassword && this.state.newPassword !== this.state.confirmPassword) {
            this.setState({errorMessage: 'Passwords do not match'});
        } else {
            this.setState({errorMessage: ''})
        }
    };

    isValid = () => {
        return this.state.newPassword && this.state.confirmPassword && this.state.newPassword === this.state.confirmPassword
    };

    render() {
        return (
            <div>
                <p>A mandatory password reset is required. Please reset your password using the form below</p>
                <form className="form-horizontal">
                    <div className="form-group">
                        <label htmlFor="newPassword" className="col-sm-2 control-label">New Password</label>
                        <div className="col-sm-10">
                            <input type="password"
                                   className="form-control"
                                   style={controlMaxWidthStyle}
                                   id="newPassword"
                                   placeholder="New Password"
                                   value={this.state.newPassword}
                                   onChange={this.inputChanged}
                                   onBlur={this.validate}/>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="confirmPassword" className="col-sm-2 control-label">Confirm Password</label>
                        <div className="col-sm-10">
                            <input type="password"
                                   className="form-control"
                                   style={controlMaxWidthStyle}
                                   id="confirmPassword"
                                   placeholder="Confirm Password"
                                   value={this.state.confirmPassword}
                                   onChange={this.inputChanged}
                                   onBlur={this.validate}/>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="col-sm-offset-2 col-sm-10">
                            {this.state.isResetting ?
                                <button type="button" className="btn btn-default" disabled>Resetting Password...</button> :
                                this.isValid() ?
                                    <button type="button" className="btn btn-default" onClick={this.resetPassword}>Reset Password</button> :
                                    <button type="submit" className="btn btn-default" disabled>Reset Password</button>}
                        </div>
                    </div>
                    {this.state.errorMessage ?
                        <div className="col-sm-offset-2 col-sm-10" style={{padding: '4px'}}>
                            <div className="alert alert-danger" style={errorMessageStyle}>{this.state.errorMessage}</div>
                        </div>
                        : undefined}
                </form>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/auth/password-reset.js